import { Component, Input, Output, EventEmitter, Injector } from "@angular/core";
import { AuthService } from "../../service/auth-service/auth-service.service";
import { Art57Section } from "../../ui/Art57Section/Art57Section";
import { Art57Node } from "../../ui/Node/Art57Node/Art57Node";
import { Art57NodeList } from "../../ui/Node/Art57Node/Art57NodeList";
import { TreeNodeATCCodeList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeATCCodeList";
import { TreeNodeAttachmentList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeAttachmentList";
import { TreeNodeAuthorisedPharmaceuticalFormList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeAuthorisedPharmaceuticalFormList";
import { TreeNodeDrugIngredientsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeDrugIngredientsList";
import { TreeNodeDrugRouteList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeDrugRouteList";
import { TreeNodeDrugsATCList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeDrugsATCList";
import { TreeNodeDrugsIndicationsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeDrugsIndicationsList";
import { TreeNodeImportedMessagesList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeImportedMessagesList";
import { TreeNodeMasterFileLocationList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeMasterFileLocationList";
import { TreeNodeMedicalDeviceList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeMedicalDeviceList";
import { TreeNodeMedicinalProductTypeList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeMedicinalProductTypeList";
import { TreeNodeOrganisationList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeOrganisationList";
import { TreeNodePharmaceuticalFormList } from "../../ui/Node/Art57Node/ListEntity/TreeNodePharmaceuticalFormList";
import { TreeNodePharmaceuticalProductsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodePharmaceuticalProductsList";
import { TreeNodePreviousEVCodeList } from "../../ui/Node/Art57Node/ListEntity/TreeNodePreviousEVCodeList";
import { TreeNodeProductAttachmentList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeProductAttachmentList";
import { TreeNodeProductsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeProductsList";
import { TreeNodeRoutesOfAdministrationList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList";
import { TreeNodeSourceList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSourceList";
import { TreeNodeSubstanceAliasList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstanceAliasList";
import { TreeNodeSubstanceAliasTranslationsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstanceAliasTranslationsList";
import { TreeNodeSubstanceAttachmentFieldsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstanceAttachmentFieldsList";
import { TreeNodeSubstanceInternationalCodeList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstanceInternationalCodeList";
import { TreeNodeSubstanceParentCodeFieldsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstanceParentCodeFieldsList";
import { TreeNodeSubstancePreviousEvCodeFieldsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstancePreviousEvCodeFieldsList";
import { TreeNodeSubstancePreviousNameCodeFieldsList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstancePreviousNameCodeFieldsList";
import { TreeNodeSubstancesList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstancesList";
import { TreeNodeSubstanceTranslationList } from "../../ui/Node/Art57Node/ListEntity/TreeNodeSubstanceTranslationList";
import { ResultList } from "../../ui/Node/ListEntity/ResultList";
import { MeddraResultList } from "../../ui/Node/MeddraNode/MeddraResultList";
import { ListView } from "../../ui/Data/ListView";
import { ToolTipUtil } from "../../ui/ToolTipUtil";
import { TreeNodeMedicinalProductsAttachments } from "../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAttachments";
import { TreeNodeMedicinalProductsAuthorisedProduct } from "../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAuthorisedProduct";

@Component({
  selector: 'app-list-detailed-view',
  templateUrl: './list-detailed-view.component.html',
  styleUrl: './list-detailed-view.component.scss'
})

export class ListDetailedViewComponent {

  @Input() selectedNode: any;
  @Output() selectedNodeChange = new EventEmitter<any>();
  @Output() removeNode = new EventEmitter<any>();
  @Output() buttonAction = new EventEmitter();
  sortProperty: number = 1;
  sortOrder = 1;

  constructor(public authService: AuthService,
    private injector: Injector
  ) {
    
  }



  onButtonAction(data: any) {
    this.buttonAction.emit(data);
  };

  onSelectedNodeChange(selectedNode: Art57Node) {
    this.selectedNodeChange.emit(selectedNode);
  }

  onRemoveNode(selectedNode: any) {
    this.removeNode.emit(selectedNode);
  }

  isListViewNode(): boolean {
    return this.selectedNode instanceof Art57NodeList ||
      this.selectedNode instanceof ResultList ||
      this.selectedNode instanceof MeddraResultList;
  }

  isListView(): boolean {
    return (this.selectedNode.data instanceof ListView)
      && (!(this.selectedNode instanceof Art57NodeList));
  }

  showDetailedAddNodes() {
    return this.selectedNode instanceof TreeNodeSubstancesList ||
      this.selectedNode instanceof TreeNodeProductsList ||
      this.selectedNode instanceof TreeNodeSourceList ||
      this.selectedNode instanceof TreeNodeOrganisationList ||
      this.selectedNode instanceof TreeNodeATCCodeList ||
      this.selectedNode instanceof TreeNodePharmaceuticalFormList ||
      this.selectedNode instanceof TreeNodeRoutesOfAdministrationList ||
      this.selectedNode instanceof TreeNodeAttachmentList ||
      this.selectedNode instanceof TreeNodeMasterFileLocationList ||
      // subnodes products
      this.selectedNode instanceof TreeNodeMedicinalProductTypeList ||
      this.selectedNode instanceof TreeNodeAuthorisedPharmaceuticalFormList ||
      this.selectedNode instanceof TreeNodePharmaceuticalProductsList ||
      this.selectedNode instanceof TreeNodeDrugRouteList ||
      this.selectedNode instanceof TreeNodeDrugIngredientsList ||
      this.selectedNode instanceof TreeNodeMedicalDeviceList ||
      this.selectedNode instanceof TreeNodeDrugsATCList ||
      this.selectedNode instanceof TreeNodeDrugsIndicationsList ||
      this.selectedNode instanceof TreeNodePreviousEVCodeList ||
      this.selectedNode instanceof TreeNodeProductAttachmentList ||
      // subnodes substances
      this.selectedNode instanceof TreeNodeSubstanceTranslationList ||
      this.selectedNode instanceof TreeNodeSubstanceAliasList ||
      this.selectedNode instanceof TreeNodeSubstanceAliasTranslationsList ||
      this.selectedNode instanceof TreeNodeSubstanceInternationalCodeList ||
      this.selectedNode instanceof TreeNodeSubstanceParentCodeFieldsList ||
      this.selectedNode instanceof TreeNodeSubstancePreviousEvCodeFieldsList ||
      this.selectedNode instanceof TreeNodeSubstanceAttachmentFieldsList ||
      this.selectedNode instanceof TreeNodeSubstancePreviousNameCodeFieldsList;
  }

  isProdAttachment() {
    return this.selectedNode instanceof TreeNodeMedicinalProductsAttachments && 
    this.selectedNode.parent?.parent instanceof TreeNodeMedicinalProductsAuthorisedProduct;
  }

  onCheckedChange(node: Art57Node) {
    node.checked = !node.checked;
  }

  select(item: any) {
    if (item.checked) {
      item.checked = !item.checked;
    } else {
      item.checked = true;
    }
  }

  sortByNum() {
    this.sortProperty = -1;
    this.sortOrder = (this.sortOrder * -1);
    this.selectedNode.children = [...this.selectedNode.children.sort((a: Art57Node, b: Art57Node) => {
      let result = 0;
      const numA: number = +a.num;
      const numB: number = +b.num;
      if (numA < numB) {
        result = -1;
      }
      if (numA > numB) {
        result = 1;
      }

      return result * this.sortOrder;
    })];
  }

  sortBy(column: number) {
    this.sortProperty = column;
    this.sortOrder = column === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.selectedNode.children = [...this.selectedNode.children.sort((a: Art57Node, b: Art57Node) => {
      
      const valueA = a.getListItem()[column];
      const valueB = b.getListItem()[column];

      // Case‑insensitive text compare
      const strA = (valueA ?? '').toString().toLowerCase();
      const strB = (valueB ?? '').toString().toLowerCase();
      const result = strA < strB ? -1 : strA > strB ? 1 : 0;

      return result * this.sortOrder;
    })];
  }

  sortIcon(property: number) {
    if (property === this.sortProperty) {
      return this.sortOrder === 1 ? '↑' : '↓';
    }
    return '';
  }

  isRemovalAlllowed() {
    return this.injector.get(Art57Section).isCreateAndSendProductSection() ||
      this.selectedNode instanceof TreeNodeImportedMessagesList;
  }

  isValid(node: any): boolean {
    //Validation only applies to Create and Send Product Reports

    return node instanceof ListView || node.data.valid || !this.injector.get(Art57Section).isCreateAndSendProductSection();
  }

  isResultList(): boolean {
    return this.selectedNode instanceof ResultList || this.selectedNode instanceof MeddraResultList;
  }

  showCheckbox(): boolean {
    return (!((this.injector.get(Art57Section).getSelectedSection() == this.injector.get(Art57Section).webtrader) &&
      (!(this.selectedNode instanceof TreeNodeImportedMessagesList))))
      &&
        (this.injector.get(Art57Section).getSelectedSection() != this.injector.get(Art57Section).medicinalProduct)
      ;
  }

  hasChildren() {
    return (this.isListViewNode() && this.selectedNode && this.selectedNode.children!.length > 0);
  }

  onItemFinderDoubleClick(item: any) {

  }


  showToolTip(item: any) {
    let result = null;
    if (ToolTipUtil.displayTooltip(item)) {
      result = ToolTipUtil.showTooltip(item,this.injector);
    }
    return result;
  }


}

